var exports = {
  "aU": "PanelSection__VIhJ_4",
  "WH": "PanelFooter__pFKmun",
  "NK": "PanelHeading__ogfk1s",
  "LH": "PanelDescription__FLkI8y",
  "kB": "PanelActions__iNgps_",
};

module.exports = exports;
